<section>
  @if (data()) {
    <app-video
      [isLoop]="data().isLoop ?? false"
      [isMuted]="data().isMuted ?? false"
      [mp4Url]="data().mp4Url"
      [previewImage]="data().image"
      [style]="{ width: '100%' }"
      [webmUrl]="data().webmUrl" />
  }
</section>
